import {
  DesignClass,
  NodeTypeName,
  ObjectClass
} from '@app/types';

type DesignItem = {
  id: string;
  _class?: DesignClass | ObjectClass;
  props: {
    nodeTypeName?: NodeTypeName;
  }
};

export function refreshCanvasItem(item: DesignItem): void {
  const isLink = (item._class) ? item._class === DesignClass.link : (
    // This is done because BaseNodeModel & BaseLinkModel do not set _class yet.
    item.props.nodeTypeName === NodeTypeName.link
  );

  if (isLink) {
    window.apm.postEventToCurrentView({
      event: {
        id: item.id,
        type: 'link',
        updatedLink: item
      },
      target: 'request-refresh-links'
    });
  } else {
    window.apm.postEventToCurrentView({
      event: {
        id: item.id,
        type: 'node',
        props: item.props
      },
      target: 'request-refresh'
    });
  }
}
